import { gunterzBold } from '@/theme/fonts';
import type { VipLevelType } from '@/types';
import { useLingui } from '@lingui/react';
import { Carousel } from '@mantine/carousel';
import { Center, Image, NumberFormatter, Paper, Stack, Text, useMatches } from '@mantine/core';
import { useState } from 'react';
import classes from './VipCarousel.module.css';
import { VipClubDetail } from './VipClubDetail';
import { vipLevels } from './vipLevels';
export const VipClubLevel: React.FC = () => {
  const {
    i18n
  } = useLingui();
  const [active, setActive] = useState<VipLevelType>(vipLevels[0]);
  const slideToScroll = useMatches({
    base: 3,
    sm: 5,
    lg: 8
  });
  return <Stack>
      <Stack gap={0} py={40} align="center">
        <Text fz={{
        base: 'sm',
        sm: 'lg'
      }} className={gunterzBold.className} c="var(--text-white)" ta="center">
          {i18n._('VIP Levels: ')}
          <Text span inherit c="var(--text-prime)">
            {i18n._('Climb the Ladder')}
          </Text>
        </Text>
        <Text w={{
        sm: 525
      }} fz="xs" c="var(--text-dark)" ta="center">
          {i18n._('Your journey to the top starts now. Play, earn XP, and unlock massive rewards as you climb the ranks of the PrimeRoll VIP Club. How high will you go?')}
        </Text>
        <Text fz="xs" c="var(--text-white)" tt="uppercase" fw={700} mt={14}>
          {i18n._('Ready to Level Up?')}
        </Text>
      </Stack>

      <Paper radius={5} p={20} mb={24} bg={`linear-gradient(180deg, ${active.bgColor}  0%, #22262B 82.87%)`}>
        <Stack mt={20} align="center">
          <Text w={{
          sm: 557
        }} fz="xs" c="var(--text-white)" tt="uppercase" ta="center" fw={700}>
            {i18n._('Each level unlocks more rewards and cooler benefits! Your VIP badge will display next to your PrimeOrb to show off your status.')}
          </Text>

          <Carousel w="100%" mt={20} dragFree align="start" controlsOffset={-50} controlSize={40} classNames={classes} slidesToScroll={slideToScroll} slideSize={{
          base: '33.33%',
          sm: '20%',
          lg: '12.5%'
        }}>
            {vipLevels.map(item => <Carousel.Slide key={item.title}>
                <Center h="100%">
                  <Stack gap={10} px={{
                base: 18,
                sm: 26,
                lg: 30
              }} py={{
                base: 16,
                sm: 20,
                lg: 24
              }} align="center" className={classes.box} mod={{
                active: active.id === item.id
              }} onClick={() => setActive(item)}>
                    <Image src={item.rankUrl} alt={item.title} w={{
                  base: 36,
                  sm: 48
                }} h={{
                  base: 36,
                  sm: 48
                }} />
                    <Text fz="xs" tt="uppercase" fw={700} c={item.textColor} ta="center">
                      {item.title}
                    </Text>
                  </Stack>
                </Center>
              </Carousel.Slide>)}
          </Carousel>

          <Stack gap={0} mt={24} mb={28} align="center">
            <Image src={active.rankUrl} alt="ranks" w={{
            base: 100,
            sm: 114
          }} h={{
            base: 100,
            sm: 114
          }} mb={20} />
            <Text fz={{
            base: 20,
            sm: 24
          }} className={gunterzBold.className} c={active.textColor}>
              {active.title}
            </Text>
            <Text c="var(--text-dark)" fz="xs" fw={700}>
              <NumberFormatter value={active.exp} thousandSeparator="," suffix={i18n._(' XP')} />
            </Text>
          </Stack>

          <VipClubDetail {...active.privileges} />
        </Stack>
      </Paper>
    </Stack>;
};